import { createStart } from "@tanstack/react-start"
import { loggingMiddleware } from "./server/logging-middleware"
import { getRouter } from "./router"
import { lexicalEditorStateAdapter } from "./serialization/lexical-adapter"

export const startInstance = createStart(() => ({
  defaultSsr: false,
  router: getRouter(),
  functionMiddleware: [loggingMiddleware],
  serializationAdapters: [lexicalEditorStateAdapter],
}))
